export const environment = {
    ambiente: 'tst',
    apiEndpoint: '',
    loginEndpoint: '',
    logoutEndpoint: '',
    urlPagInicial: `http://${window.location.host}/`,
    ssoLink:'https://cfc-sso-tst.basis.com.br',
    auth: {
      detailsUrl: "/api/user/details",
      loginUrl: "/api/login",
      logoutUrl: "/api/logout",
      userStorage: localStorage,
      userStorageIndex: "user"
    },
  };
  


// WEBPACK FOOTER //
// ./src/environments/environment.ts